<div class='MoveContacts'>
  <div class='Breadcrumbs mb-5'>
    <div class='Breadcrumbs-items'>
      <a [routerLink]="['/user_contacts', 'user_groups']"
      >
        <mat-icon class='Breadcrumbs-icon back'
        >keyboard_backspace
        </mat-icon
        >
      </a
      >
      <a
        [routerLink]="['/user_contacts', 'user_groups']"
        class='Breadcrumbs-item first'
      >Contacts</a
      >
      <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
      <span class='Breadcrumbs-item'>Move Contacts</span>
    </div>
  </div>
  <app-table
    #tableComponent
    (rowSelected)='onSelection($event)'
    *ngIf='tableReady'
    [columns]='tableColumns'
    [dataSourceParams]='tableDataSourceParams'
    [dataSource]='dataSource'
    [filterGroups]='tableFilterGroups'
    [selectable]='true'
    [useRouteNavigation]='false'></app-table>
</div>
